import { FC, ReactNode, useState } from "react";
import { StayDataType } from "data/types";
import HeaderFilter from "./HeaderFilter";
import { useNavigate } from "react-router-dom";
import { useData } from "data/data-provider";
import ExpandingFleetGrid from "designs/DesignB/components/FleetGrid/ExpandingFleetGrid";

// OTHER DEMO WILL PASS PROPS
const DEMO_DATA: StayDataType[] = [];

//
export interface SectionGridFeaturePlacesProps {
  stayListings?: StayDataType[];
  gridClass?: string;
  heading?: ReactNode;
  subHeading?: ReactNode;
  headingIsCenter?: boolean;
  tabs?: string[];
}

const SectionGridFeaturePlaces: FC<SectionGridFeaturePlacesProps> = ({
  stayListings = DEMO_DATA,
  gridClass = "",
  heading = "Popular Cars",
  subHeading = "Popular places to stay that Chisfis recommends for you",
  headingIsCenter,
  tabs = ["New York", "Tokyo", "Paris", "London"],
}) => {
  const { ourVehicles, ourVehiclesLoading, ourVehiclesSettled } = useData();
  const [visibleCarsCount, setVisibleCarsCount] = useState<number>(8); // Track how many cars are visible
  const [expanded, setExpanded] = useState<boolean>(false); // Track if all cars are visible
  const navigate = useNavigate();

  // Determine how many cars to show based on visibleCarsCount
  const carsToDisplay = ourVehicles?.slice(0, visibleCarsCount);

  const handleShowMore = () => {
    // Increment the visible cars count by 8 each time
    setVisibleCarsCount((prevCount) => prevCount + 8);
    if (ourVehicles && visibleCarsCount + 8 >= ourVehicles.length) {
      setExpanded(true); // Set expanded to true if all cars are visible
    }
  };

  const handleShowLess = () => {
    // Collapse back to the first 8 cars
    setVisibleCarsCount(8);
    setExpanded(false); // Collapse the list
  };

  return (
    <div className="nc-SectionGridFeaturePlaces relative">
      <HeaderFilter count={!ourVehiclesLoading && ourVehicles ? ourVehicles.length : undefined} />
      {ourVehiclesLoading ? (
        <div className="flex justify-center items-center">
          <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full border-t-transparent border-secondary-text-color"></div>
        </div>
      ) : (
        // 1NOW-11219: a card opens the car's details in place; Book now in there goes on to the
        // car page, as the card's own button used to.
        <ExpandingFleetGrid
          cars={carsToDisplay ?? []}
          gridClassName={`sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 ${gridClass}`}
          pool={ourVehicles ?? []}
          onReveal={(n) => {
            const count = Math.ceil(n / 8) * 8;
            setVisibleCarsCount((cur) => Math.max(cur, count));
            if (ourVehicles && count >= ourVehicles.length) setExpanded(true);
          }}
          settled={!ourVehiclesLoading && ourVehiclesSettled !== false}
          onBook={(car) => navigate("/car-listing-detail?selectedCarId=" + car.id)}
        />
      )}
      {/* Show "Load more" if not all cars are shown */}
      {!expanded && ourVehicles?.length > visibleCarsCount && (
        <div className="flex mt-10 justify-center items-center">
          <button type="button" className="db-btn db-btn--ghost" onClick={handleShowMore}>
            Load More
          </button>
        </div>
      )}

      {/* Show "Load less" if the list is expanded */}
      {expanded && (
        <div className="flex mt-10 justify-center items-center">
          <button type="button" className="db-btn db-btn--ghost" onClick={handleShowLess}>
            Load Less
          </button>
        </div>
      )}
    </div>
  );
};

export default SectionGridFeaturePlaces;
